module.exports = __webpack_public_path__ + "static/img/communication.c4c903f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ela/communication.jpg
// module id = GOOn
// module chunks = 1